module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/malgorzata-lesinska-4e745a6729d6b556d3cb10f244f92574.webp";